import axios from '@/tools/axios/axios'
import { storage } from '@/tools/storage'
import { STORAGE } from '@/tools/storage/constants'

const SUCCESS_API_URL = 'api/locations'

export default {
  get() {
    return storage.session.get(STORAGE.geolocation)
  },
  request() {
    return new Promise((resolve, reject) => {
      if (!window.sessionStorage || !navigator.geolocation) reject()

      storage.session.set(STORAGE.attemptedGeolocation, true)

      navigator.geolocation.getCurrentPosition(
        position => {
          resolve(this.sendLocation(position))
        },
        error => {
          if (error.constructor.name !== 'GeolocationPositionError') throw error
        }
      )
    })
  },
  hasAttempted() {
    return !!storage.session.get(STORAGE.attemptedGeolocation)
  },
  sendLocation(position) {
    const { latitude, longitude } = position.coords

    return axios.post(`${location.origin}/${SUCCESS_API_URL}`, {
      latitude,
      longitude
    })
      .then((response) => {
        const city = response.data.user_city
        const state = response.data.user_state
        const geolocation = { latitude, longitude, city, state }

        storage.session.set(STORAGE.geolocation, geolocation)

        return geolocation
      })
  }
}
